import type { DamageType } from "./damageType";
import { PhysicalThing } from "./physicalThing";
import type { Thing } from "./thing";
import type { XY } from "./xy";

export const STD_BASE_HP = 10;

export abstract class PhysicalThingWithHp extends PhysicalThing {
	hp: number = STD_BASE_HP;
	maxHp: number = STD_BASE_HP;
	damageMultipliers: Map<DamageType, number> = new Map();

	constructor(xy: XY, blocksMovement: boolean = false) {
		super(xy, blocksMovement);
	}

	applyDamage(type: DamageType | null, amount: number, source: Thing | null): number {
		if (!this.active) return 0;
		const multiplier = type !== null ? (this.damageMultipliers.get(type) ?? 1.0) : 1.0;
		const effectiveDmg = multiplier > 0 && amount > 0 ? Math.max(1, Math.floor(amount * multiplier)) : 0;

		let newHp = Math.max(this.hp - effectiveDmg, 0);
		newHp = Math.min(newHp, this.maxHp);
		this.hp = newHp;

		if (newHp <= 0) {
			this.onZeroHp(source, type);
		}

		return effectiveDmg;
	}

	kill(type?: DamageType | null, source?: Thing | null): void {
		this.applyDamage(type ?? null, this.hp, source ?? null);
	}

	protected onZeroHp(_source: Thing | null, _type: DamageType | null): void {
		this.board!.removeAtEndOfTurn(this);
	}

	protected restoreBaseFields(data: any): void {
		this.visualId = data.visualId;
		this.hp = data.hp;
		this.maxHp = data.maxHp;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			hp: this.hp,
			maxHp: this.maxHp,
			damageMultipliers: [...this.damageMultipliers.entries()],
		};
	}
}
